/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { LedIndicator } from '../../../../components/widgets/led-indicator';

import { t } from '../../../../locales/i18n';
import { Icon } from '../../../../components/icon';
import { SemanticICONS } from 'semantic-ui-react';
import styled from 'styled-components';
import { colors } from '@nextinq/ui-toolkit';
import { sizes } from '../../../../themes/sizes';

const Item = styled.li`
  list-style-type: none;
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: ${sizes.margins.normal};
  align-items: start;
  margin-bottom: ${sizes.margins.large};
`;

const Icons = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-items: center;
  align-items: center;
  gap: ${sizes.margins.normal};
`;
const Broken = styled.div`
  color: ${colors.status.error};
`;

function getDeviceIconName(props: any): SemanticICONS {
  let iconName: SemanticICONS = 'help';
  switch (props.deviceType) {
    case 'display': {
      iconName = 'tv';
      break;
    }
    case 'cloud-qsrv': {
      iconName = 'server';
      break;
    }
    case 'kiosk': {
      iconName = 'tablet alternate';
      break;
    }
  }
  return iconName;
}

function CheckResult(props: any) {
  const { status, name } = props;
  return (
    <li>
      <LedIndicator size="small" severity={status} />
      <span>{t(`deviceStatusCheck.${name}`, { _: name })}</span>
    </li>
  );
}

function DeviceStatusResult(props: any) {
  const { isConnected, deviceType, deviceName } = props;
  const name = deviceName || '';
  if (!isConnected) {
    return (
      <span>
        <p>{t(`deviceStatusResult.${deviceType}.header`, { name })}</p>
        <p>{t(`deviceDisconnected`)}</p>
      </span>
    );
  }
  const checks = props.checks;

  return (
    <div>
      <p>{t(`deviceStatusResult.${deviceType}.header`, { name })}</p>
      <p>{t(`deviceStatusResult.ok`)}</p>
      <ol>
        {checks.errors.map((check: any, i: number) => (
          <CheckResult key={i} status="error" name={check.code} />
        ))}
      </ol>
      <ol>
        {checks.warnings.map((check: any, i: number) => (
          <CheckResult key={i} status="warn" name={check.code} />
        ))}
      </ol>
    </div>
  );
}

export function DeviceStatus(props: any) {
  const { isConnected, finalStatus } = props;
  return (
    <Item>
      <Icons>
        {isConnected && <LedIndicator size="small" severity={finalStatus} />}
        {!isConnected && (
          <Broken>
            <Icon size="small" name="broken chain" />
          </Broken>
        )}
        <Icon name={getDeviceIconName(props)} />
      </Icons>

      <DeviceStatusResult {...props} />
    </Item>
  );
}
